import type {} from '@tanstack/query-core';
import { _getBootstrap } from './GetBootstrap';
import { _getInitialAuthInfo } from './GetInitialAuthInfo';
import { _isAllowedIp } from './IsAllowedIp';
import { _pollActiveGrantRequestStatus } from './PollActiveGrantRequestStatus';
import { _requestActiveGrant } from './RequestActiveGrant';
import { _revokeActiveGrant } from './RevokeActiveGrant';

export const useAuth: {
  readonly GetBootstrap: typeof _getBootstrap;
  readonly GetInitialAuthInfo: typeof _getInitialAuthInfo;
  readonly IsAllowedIp: typeof _isAllowedIp;
  readonly PollActiveGrantRequestStatus: typeof _pollActiveGrantRequestStatus;
  readonly RequestActiveGrant: typeof _requestActiveGrant;
  readonly RevokeActiveGrant: typeof _revokeActiveGrant;
} = {
  GetBootstrap: _getBootstrap,
  GetInitialAuthInfo: _getInitialAuthInfo,
  IsAllowedIp: _isAllowedIp,
  PollActiveGrantRequestStatus: _pollActiveGrantRequestStatus,
  RequestActiveGrant: _requestActiveGrant,
  RevokeActiveGrant: _revokeActiveGrant,
} as const;
